// src/lib/layouts/applyClipPosition.ts
import {
  deriveClipPosition,
  isValidFractionalRect,
  type FractionalRect,
} from './deriveClipPosition';

export type ClipPosition = 'top' | 'bottom';

/** Move a free-floating satisfatorio cell onto the requested split-axis side
 *  (portrait: top/bottom; landscape: left/right). Missing or junk rects only
 *  update `clipPosition`, which is enough for the legacy stacked split. A
 *  cell already on that side is left in place. */
export function applyClipPosition(
  clipRect: FractionalRect | undefined | null,
  next: ClipPosition,
  isLandscape: boolean,
): { clipPosition: ClipPosition; clipRect?: FractionalRect } {
  if (!isValidFractionalRect(clipRect)) {
    return { clipPosition: next };
  }
  if (deriveClipPosition(clipRect, isLandscape) === next) {
    return { clipPosition: next, clipRect };
  }
  const flipped: FractionalRect = isLandscape
    ? { ...clipRect, x: 1 - clipRect.x - clipRect.w }
    : { ...clipRect, y: 1 - clipRect.y - clipRect.h };
  return { clipPosition: next, clipRect: flipped };
}
